export default __webpack_public_path__ + "static/media/ic-para-color.bc0f97e7.svg";